import { Injectable } from '@angular/core';

// Spoofable UX advice only; never an authorization or hardware assertion.
export function isTvUserAgent(userAgent: string): boolean {
  if (/\b(iphone|ipad|ipod|mobile|phone|watch|wear|quest|oculusbrowser)\b/i.test(userAgent)) return false;
  return /\b(smart[ -]?tv|hbbtv|appletv|netcast|android[ -]?tv|google[ -]?tv)\b/i.test(userAgent)
    || /\b(webos|tizen)\b.*\b(tv|television)\b/i.test(userAgent)
    || /\b(tv|television)\b.*\b(webos|tizen)\b/i.test(userAgent);
}

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectorService {

  private readonly _userAgent = navigator.userAgent.toLowerCase();

  public getPlatformString = (): string => {
    if (this._userAgent.includes('oculusbrowser')) return 'Meta Quest / Oculus';
    if (isTvUserAgent(this._userAgent)) return 'Smart TV';
    if (/android/i.test(this._userAgent)) return 'Android';
    if (/iphone|ipad|ipod/i.test(this._userAgent)) return 'iOS';
    if (!/mobile|android|iphone|ipad|ipod|smart-tv|smarttv|appletv|hbbtv|netcast|webos|tizen/i.test(this._userAgent)) return 'PC';
    return 'Desconocido';
  }

  public getPlatformIcon = (): string => {
    if (this._userAgent.includes('oculusbrowser')) return 'view_in_ar';
    if (isTvUserAgent(this._userAgent)) return 'tv';
    if (/android/i.test(this._userAgent) || /iphone|ipad|ipod/i.test(this._userAgent)) return 'phone_android';
    if (!/mobile|android|iphone|ipad|ipod|smart-tv|smarttv|appletv|hbbtv|netcast|webos|tizen/i.test(this._userAgent)) return 'computer';
    return 'block';
  }

  public getUserAgent = (): string => this._userAgent;
}
